import { Dic } from "$utils";
const tableOption = function () {
  return {
    stripe: true,
    page: true,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "车牌号",
        prop: "plateCode",
        search: true,
        clearable: true
      },
      {
        label: "车主姓名",
        prop: "ownerName",
        search: true,
        clearable: true
      },
      {
        label: "车辆类型",
        prop: "vehicleType",
        search: true,
        clearable: true,
        type: "select",
        dicData: Dic.find("SENU038"),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue("SENU038", value);
          }
          return "";
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU038", value) : "";
        }
      },
      {
        label: "车辆颜色",
        prop: "vehicleColor",
        type: "select",
        search: false,
        dicData: Dic.find("SENU039"),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue("SENU039", value);
          }
          return "";
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU039", value) : "";
        }
      },
      {
        label: "车牌颜色",
        prop: "plateColor",
        type: "select",
        search: false,
        dicData: Dic.find("SENU040"),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue("SENU040", value);
          }
          return "";
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU040", value) : "";
        }
      },
      {
        label: "生效时间",
        prop: "effectiveTime",
        search: true,
        clearable: true,
        type: "daterange"
      },
      {
        label: "失效时间",
        prop: "expirationTime",
        search: false,
        clearable: true,
        type: "daterange"
      },
      {
        label: "授权时间",
        prop: "createTime",
        search: false,
        clearable: true,
        type: "daterange"
      }
    ]
  };
};

export default tableOption;
